import type { User } from '@patrianna/shared-patrianna-types/store/UserModule'

export function stepOneBtnText(kycStatus: User['kycStatus']) {
  if (kycStatus === 'in_review') {
    return 'step 1: in progress'
  }

  if (kycStatus === 'declined') {
    return 'please re-submit'
  }

  // flow on second step, it means first step is confirmed
  // @TODO but there might be an issue when identity document not uploaded or failed
  // and backend passed to second step
  if (['doc_review', 'doc_declined', 'confirmed'].includes(kycStatus)) {
    return 'verified'
  }

  if (kycStatus === 'id_confirmed') {
    return 'verified'
  }

  return 'submit ID'
}

export function stepTwoBtnText(kycStatus: User['kycStatus']) {
  if (kycStatus === 'doc_review') {
    return 'step 2: in progress'
  }

  if (kycStatus === 'doc_declined') {
    return 'please re-submit'
  }

  if (kycStatus === 'confirmed') {
    return 'verified'
  }

  return 'submit proof of address'
}
